function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import forIn from 'lodash/forIn';
import fromPairs from 'lodash/fromPairs';
import map from 'lodash/map';
import pick from 'lodash/pick';
import unset from 'lodash/unset';
import { AppContext } from 'context';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Information from 'modules/Information';
import * as constants from '../../constants';
import messages from '../../messages';
import MissingConsents from '../../partials/MissingConsents';
class MissingLegalConsents extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidMount() {
        this.onSetLegalConsentsRules();
    }
    get missingMandatoryConsents() {
        return filter(this.props.consentsTemplate, (c)=>{
            if (!c.isMandatory) return false;
            const { legalConsentId } = c;
            const approval = find(this.props.information.legalConsentApprovals, {
                legalConsentId
            });
            return !approval || !approval.decision;
        });
    }
    onSetLegalConsentsRules() {
        this.requiredRules = {};
        const { requiredRules } = this;
        this.legalConsentsFields = [];
        forEach(this.missingMandatoryConsents, (legalConsent)=>{
            const { legalConsentId, isMandatory } = legalConsent;
            const legalConsentFieldId = `legalConsent-${legalConsentId}`;
            this.legalConsentsFields.push(legalConsentFieldId);
            if (isMandatory) {
                this.validatorRules[legalConsentFieldId] = 'required, bool';
                requiredRules[legalConsentFieldId] = 'required';
            } else {
                this.validatorRules[legalConsentFieldId] = 'bool';
            }
        });
        this.requiredRules = requiredRules;
        this.onSetValues(fromPairs(map(this.legalConsentsFields, (lcf)=>[
                lcf,
                undefined
            ])));
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const legalConsents = pick(validatedValues, this.legalConsentsFields);
            const legalConsentApprovals = [];
            forIn(legalConsents, (value, key)=>{
                const id = parseInt(key.split('-')[1], 10);
                legalConsentApprovals.push({
                    legalConsentId: id,
                    decision: value
                });
                unset(validatedValues, `legalConsent-${id}`);
            });
            validatedValues.legalConsentApprovals = legalConsentApprovals;
            this.props.onSubmit(validatedValues);
        }
    }
    renderActions() {
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-8",
            children: /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: App.messages.buttons.continue,
                className: "btn--block btn--filled",
                isDisabled: this.isDisabled,
                isInProgress: this.state.isInProgress,
                onClickDisabled: ()=>this.onCheck()
            })
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx(MissingConsents, {}),
                this.renderActions()
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("h1", {
                className: "text--h2",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.legalConsents))
            })
        });
    }
    renderInfo() {
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph mb-6",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.legalConsents))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "pageContentBox",
            "data-testid": "missing-legal-consents",
            children: [
                this.renderHeader(),
                this.renderInfo(),
                this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
        this.legalConsentsFields = [];
    }
}
_define_property(MissingLegalConsents, "contextType", AppContext);
_define_property(MissingLegalConsents, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    information: PropTypes.object,
    // Implicit props
    consentsTemplate: PropTypes.array,
    localizationResources: PropTypes.object
}));
const mapStateToProps = ()=>(state)=>({
            consentsTemplate: Information.selectors.consentsTemplate(state),
            formValues: App.selectors.formSelector(constants.INFORMATION_FORM)(state),
            localizationResources: App.selectors.localizationResources(state)
        });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.INFORMATION_FORM;
    return {
        onSubmit: (information)=>dispatch(Information.actions.sendInformation(information)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName))
    };
};
const ConnectedLegalConsents = connect(mapStateToProps, mapDispatchToProps)(MissingLegalConsents);
export default ConnectedLegalConsents;
